<template>
  <slot
    :timeline
    :dates
    :slider-date
    :handle-update-timeline
    :handle-update-slider-date
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { RepositoryTimeline } from '@types'

import useAnalyticsStore from '@/store/analytics'
import { useRepositoriesStore } from '@/store/repositories/index'

const analyticsStore = useAnalyticsStore()
const repositoriesStore = useRepositoriesStore()

const timeline = computed(() => repositoriesStore.getCurrentTimeline)
const dates = computed(() => analyticsStore.getDatesRange)

const sliderDate = computed(() => analyticsStore.getDate)

const handleUpdateTimeline = async (
  timeline: RepositoryTimeline,
  isEndChanged = false,
) => {
  analyticsStore.cancel()
  analyticsStore.refresh(isEndChanged ? undefined : ['tree'])

  await repositoriesStore.setCurrentTimeline(timeline, isEndChanged)
  analyticsStore.markAsDeprecated(isEndChanged ? [] : ['tree', 'irr_moic'])
}

const handleUpdateSliderDate = (value: string) => {
  analyticsStore.setDate(value)
}
</script>
